import { MAX_SUB_EFFICE_COUNT } from "constants/constants";
import React from "react";

const PrettySubEfficeNumber = ({ number }) => {
  let display = 0;
  if (number === 0) {
    display = "+";
  } else if (number > MAX_SUB_EFFICE_COUNT) {
    display = MAX_SUB_EFFICE_COUNT + "+";
  } else {
    display = number;
  }
  return <span>{`${display}`}</span>;
};

export default PrettySubEfficeNumber;
